export default __webpack_public_path__ + "static/media/icon-ryby.f1cdfaaf.svg";